(function () {
  'use strict';

  var API_BASE = 'https://api.tripcnguide.com';
  var MAX_FILE_SIZE = 8 * 1024 * 1024;
  var ALLOWED_FILE_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'application/pdf'];
  var ALLOWED_FILE_EXTENSION = /\.(jpe?g|png|webp|pdf)$/i;
  var POLL_INTERVAL_MS = 3500;
  var POLL_TIMEOUT_MS = 15 * 60 * 1000;
  var FREE_PRODUCT = {
    sku: 'ESIM-CN-FREE-3D',
    name: 'Free China eSIM · 3 days',
    regionCode: 'CN_HK_MO',
    planType: 'DAILY_QUOTA',
    dataAmount: 300,
    dataUnit: 'MB',
    validityDays: 3,
    priceUsd: 0,
    isFree: true,
    requiresReview: true,
    freeTrialNotice: 'Unlimited data: 300 MB/day high-speed, then unlimited at 48 KB/s (resets every 24 hours). One free eSIM per traveler. Approved within 1 business day.'
  };
  var root = document.getElementById('esim-page');
  var configurator = root && root.querySelector('[data-esim-paid-configurator]');
  var checkout = document.querySelector('[data-esim-checkout]');

  if (!root || !configurator || !checkout) return;

  var productsState = configurator.querySelector('[data-esim-products-state]');
  var productsMessage = configurator.querySelector('[data-esim-products-message]');
  var productsRetry = configurator.querySelector('[data-esim-products-retry]');
  var daysField = configurator.querySelector('[data-esim-days-field]');
  var dayList = configurator.querySelector('[data-esim-day-list]');
  var plansField = configurator.querySelector('[data-esim-plans-field]');
  var dataGroups = configurator.querySelector('[data-esim-data-groups]');
  var planInfo = configurator.querySelector('[data-esim-plan-info]');
  var planNote = configurator.querySelector('[data-esim-plan-note]');
  var planDetails = configurator.querySelector('[data-esim-plan-details]');
  var availability = configurator.querySelector('[data-esim-availability]');
  var priceOutput = configurator.querySelector('[data-esim-price]');
  var mobilePlan = configurator.querySelector('[data-esim-mobile-plan]');
  var mobilePrice = configurator.querySelector('[data-esim-mobile-price]');
  var mobileBar = configurator.querySelector('[data-esim-mobile-bar]');
  var mobileBuyButton = configurator.querySelector('.esim-paid__mobile-buy');
  var desktopBuyButton = configurator.querySelector('.esim-paid__checkout [data-esim-buy]');
  var buyButtons = configurator.querySelectorAll('[data-esim-buy]');

  var checkoutForm = checkout.querySelector('[data-esim-checkout-form]');
  var checkoutEmail = checkout.querySelector('[data-esim-checkout-email]');
  var checkoutPassport = checkout.querySelector('[data-esim-checkout-passport]');
  var passportUpload = checkout.querySelector('[data-esim-passport-upload]');
  var passportRemove = checkout.querySelector('[data-esim-passport-remove]');
  var passportName = checkout.querySelector('[data-esim-passport-name]');
  var checkoutPlan = checkout.querySelector('[data-esim-checkout-plan]');
  var checkoutDays = checkout.querySelector('[data-esim-checkout-days]');
  var checkoutDelivery = checkout.querySelector('[data-esim-checkout-delivery]');
  var checkoutPrice = checkout.querySelector('[data-esim-checkout-price]');
  var checkoutStatus = checkout.querySelector('[data-esim-checkout-status]');
  var checkoutSubmit = checkout.querySelector('[data-esim-checkout-submit]');
  var checkoutCloseButtons = checkout.querySelectorAll('[data-esim-checkout-close]');
  var recipientInput = checkoutForm.elements.recipientEmail;
  var summaryLabel = checkout.querySelector('[data-esim-checkout-summary-label]');
  var totalLabel = checkout.querySelector('[data-esim-checkout-total-label]');
  var paymentNote = checkout.querySelector('[data-esim-checkout-payment-note]');
  var paymentNoteText = checkout.querySelector('[data-esim-checkout-payment-note-text]');
  var freeNotice = checkout.querySelector('[data-esim-checkout-free-notice]');
  var checkoutEyebrow = checkout.querySelector('[data-esim-checkout-eyebrow]');
  var checkoutHeading = checkout.querySelector('[data-esim-checkout-heading]');
  var checkoutSubheading = checkout.querySelector('[data-esim-checkout-subheading]');
  var waitingView = checkout.querySelector('[data-esim-checkout-waiting]');
  var waitingRef = waitingView.querySelector('[data-esim-checkout-waiting-ref]');
  var waitingTotal = waitingView.querySelector('[data-esim-checkout-waiting-total]');
  var waitingStatusEl = waitingView.querySelector('[data-esim-checkout-waiting-status]');
  var waitingStatusText = waitingView.querySelector('[data-esim-checkout-waiting-status-text]');
  var waitingReopen = waitingView.querySelector('[data-esim-checkout-waiting-reopen]');
  var waitingCancel = waitingView.querySelector('[data-esim-checkout-waiting-cancel]');
  var waitingDone = waitingView.querySelector('[data-esim-checkout-waiting-done]');
  var waitingMyOrders = waitingView.querySelector('[data-esim-checkout-my-orders]');
  var waitingTitle = waitingView.querySelector('[data-esim-checkout-waiting-title]');
  var waitingCopy = waitingView.querySelector('[data-esim-checkout-waiting-copy]');
  var waitingVisual = waitingView.querySelector('[data-esim-checkout-waiting-visual]');
  var waitingIconPending = waitingView.querySelector('.esim-checkout__waiting-icon--pending');
  var waitingIconSuccess = waitingView.querySelector('.esim-checkout__waiting-icon--success');
  var waitingDefaults = {
    title: waitingView.querySelector('[data-esim-checkout-waiting-title]').textContent,
    copy: waitingView.querySelector('[data-esim-checkout-waiting-copy]').textContent.trim()
  };
  var checkoutDefaults = {
    eyebrow: checkoutEyebrow.textContent,
    heading: checkoutHeading.textContent,
    subheading: checkoutSubheading.textContent
  };

  var state = {
    products: [],
    selectedDays: 3,
    selectedProduct: null,
    freeProduct: FREE_PRODUCT,
    quote: null,
    quoteLoading: false,
    quoteRequestId: 0,
    loadingProducts: false,
    submitting: false,
    checkoutSelection: null,
    payment: null,
    couponSelector: null
  };
  var uploadedDocuments = Object.create(null);

  function apiError(message, code, status) {
    var error = new Error(message || 'The eSIM service returned an error.');
    error.code = Number(code) || 0;
    error.status = Number(status) || 0;
    return error;
  }

  async function apiRequest(path, options) {
    var config = options || {};
    var headers = { Accept: 'application/json' };
    var headerName;

    if (config.headers) {
      for (headerName in config.headers) {
        if (Object.prototype.hasOwnProperty.call(config.headers, headerName)) {
          headers[headerName] = config.headers[headerName];
        }
      }
    }

    if (config.json !== undefined) {
      headers['Content-Type'] = 'application/json';
    }

    if (config.authorized) {
      var auth = window.TripCNAuth;
      var accessToken = auth && typeof auth.getAccessToken === 'function' ? auth.getAccessToken() : '';
      if (accessToken) headers.Authorization = 'Bearer ' + accessToken;
    }

    var response;
    try {
      response = await window.fetch(API_BASE + path, {
        method: config.method || 'GET',
        headers: headers,
        body: config.json !== undefined ? JSON.stringify(config.json) : config.body
      });
    } catch (error) {
      throw apiError('Unable to reach the eSIM service. Check your connection and try again.');
    }

    var payload;
    try {
      payload = await response.json();
    } catch (error) {
      throw apiError('The eSIM service returned an unexpected response.', response.status, response.status);
    }

    if (!response.ok || !payload || payload.code !== 200) {
      throw apiError(payload && payload.msg, payload && payload.code, response.status);
    }

    return payload.data;
  }

  function friendlyError(error, fallback, context) {
    var code = Number(error && (error.code || error.status)) || 0;
    var mode = context && context.mode;
    if (code === 409 && mode === 'free') {
      return error && error.message
        ? error.message
        : 'You have already claimed a free eSIM. Only one free application is allowed per traveler.';
    }
    if (code === 400) return 'Check the selected plan and traveler details, then try again.';
    if (code === 401) return 'Your session has expired. Log in again to continue.';
    if (code === 403) return 'This account cannot complete the requested action.';
    if (code === 404) return 'This eSIM plan is no longer available. Choose another plan.';
    if (code === 409) return 'This plan has just sold out. Choose another plan or try again later.';
    if (code === 502) return 'PayPal is temporarily unavailable. Your card has not been charged.';
    if (code >= 500) return 'The eSIM service is temporarily unavailable. Try again shortly.';
    return error && error.message ? error.message : (fallback || 'Something went wrong. Try again.');
  }

  function money(amount, currency) {
    var value = Number(amount);
    if (!Number.isFinite(value)) return 'Price unavailable';
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency || 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    } catch (error) {
      return '$' + value.toFixed(2) + ' ' + (currency || 'USD');
    }
  }

  function numberLabel(value) {
    var number = Number(value);
    if (!Number.isFinite(number)) return '';
    return Number.isInteger(number) ? String(number) : String(number).replace(/0+$/, '').replace(/\.$/, '');
  }

  function dataLabel(product) {
    var amount = numberLabel(product.dataAmount);
    var unit = String(product.dataUnit || '').toUpperCase();
    if (product.planType === 'DAILY_QUOTA') return amount + ' ' + unit + ' / day';
    if (product.planType === 'TOTAL_QUOTA') return amount + ' ' + unit + ' total';
    return product.dataDisplay || product.name || 'eSIM plan';
  }

  function planSignature(product) {
    return [
      product.regionCode || '',
      product.planType || '',
      numberLabel(product.dataAmount),
      String(product.dataUnit || '').toUpperCase()
    ].join('|');
  }

  function tierFor(product, days) {
    if (!Array.isArray(product.priceTiers)) return null;
    for (var index = 0; index < product.priceTiers.length; index += 1) {
      if (Number(product.priceTiers[index].days) === Number(days)) return product.priceTiers[index];
    }
    return null;
  }

  function previewPrice(product, days) {
    if (product.pricingMode === 'TIERED') {
      var tier = tierFor(product, days);
      return tier ? Number(tier.price) : NaN;
    }
    if (product.pricingMode === 'PER_DAY') return Number(product.priceUsd) * Number(days);
    return Number(product.priceUsd);
  }

  function supportsDays(product, days) {
    if (product.pricingMode === 'TIERED') return Boolean(tierFor(product, days));
    if (product.pricingMode === 'PER_DAY') {
      return Number(days) >= Number(product.minDays || 1) &&
        Number(days) <= Number(product.maxDays || days);
    }
    return Number(product.validityDays) === Number(days);
  }

  function scopedProducts(products) {
    return products.filter(function (product) {
      return product &&
        product.regionCode === 'CN_HK_MO' &&
        product.pricingMode === 'TIERED' &&
        (product.planType === 'DAILY_QUOTA' || product.planType === 'TOTAL_QUOTA');
    });
  }

  function availableDays(products) {
    var values = Object.create(null);
    products.forEach(function (product) {
      if (!Array.isArray(product.priceTiers)) return;
      product.priceTiers.forEach(function (tier) {
        var day = Number(tier.days);
        if (day > 0) values[day] = true;
      });
    });
    return Object.keys(values).map(Number).sort(function (first, second) {
      return first - second;
    });
  }

  function productsForDay(days) {
    var bestBySignature = Object.create(null);

    state.products.filter(function (product) {
      return supportsDays(product, days);
    }).forEach(function (product) {
      var signature = planSignature(product);
      var current = bestBySignature[signature];
      if (!current) {
        bestBySignature[signature] = product;
        return;
      }

      var productInStock = Number(product.availableStock) > 0;
      var currentInStock = Number(current.availableStock) > 0;
      if (productInStock && !currentInStock) {
        bestBySignature[signature] = product;
        return;
      }
      if (productInStock === currentInStock &&
          previewPrice(product, days) < previewPrice(current, days)) {
        bestBySignature[signature] = product;
      }
    });

    return Object.keys(bestBySignature).map(function (signature) {
      return bestBySignature[signature];
    }).sort(function (first, second) {
      if (first.planType !== second.planType) {
        return first.planType === 'DAILY_QUOTA' ? -1 : 1;
      }
      return Number(first.dataAmount) - Number(second.dataAmount);
    });
  }

  function setProductsMessage(viewState, message, retry) {
    productsState.dataset.state = viewState;
    productsMessage.textContent = message;
    productsRetry.hidden = !retry;
  }

  function setPrice(value) {
    priceOutput.textContent = value;
    mobilePrice.textContent = value;
  }

  function setAvailability(message, viewState) {
    availability.hidden = false;
    availability.dataset.state = viewState || 'notice';
    availability.textContent = message;
  }

  function setBuyButtonState(enabled, desktopLabel, mobileLabel) {
    buyButtons.forEach(function (button) {
      button.disabled = !enabled;
      button.setAttribute('aria-disabled', enabled ? 'false' : 'true');
      button.textContent = button === mobileBuyButton ? mobileLabel : desktopLabel;
    });
  }

  function canPurchase() {
    return Boolean(
      state.selectedProduct &&
      state.quote &&
      !state.quoteLoading &&
      !state.submitting &&
      Number(state.selectedProduct.availableStock) > 0
    );
  }

  function syncBuyButtons() {
    if (!state.loadingProducts) {
      daysField.disabled = state.submitting;
      plansField.disabled = state.submitting;
    }
    if (state.submitting) {
      setBuyButtonState(false, 'Preparing PayPal…', 'Opening PayPal');
      return;
    }
    if (state.loadingProducts) {
      setBuyButtonState(false, 'Checking availability…', 'Wait');
      return;
    }
    if (state.quoteLoading) {
      setBuyButtonState(false, 'Confirming price…', 'Checking');
      return;
    }
    if (!state.selectedProduct) {
      setBuyButtonState(false, 'Choose a plan', 'Choose');
      return;
    }
    if (!state.quote) {
      setBuyButtonState(false, 'Price unavailable', 'Unavailable');
      return;
    }
    if (Number(state.selectedProduct.availableStock) <= 0) {
      setBuyButtonState(false, 'Temporarily sold out', 'Sold out');
      return;
    }
    setBuyButtonState(true, 'Continue to PayPal →', 'Buy now');
  }

  function renderDays() {
    var days = availableDays(state.products);
    dayList.textContent = '';

    if (!days.length) return;
    if (days.indexOf(state.selectedDays) === -1) {
      state.selectedDays = days.indexOf(3) !== -1 ? 3 : days[0];
    }

    days.forEach(function (day) {
      var button = document.createElement('button');
      button.className = 'esim-paid__day';
      button.type = 'button';
      button.dataset.esimDays = String(day);
      button.setAttribute('aria-pressed', day === state.selectedDays ? 'true' : 'false');
      button.textContent = day + (day === 1 ? ' day' : ' days');
      dayList.appendChild(button);
    });
  }

  function createPlanOption(product) {
    var label = document.createElement('label');
    var input = document.createElement('input');
    var card = document.createElement('span');
    var title = document.createElement('strong');
    var meta = document.createElement('small');
    var inStock = Number(product.availableStock) > 0;

    label.className = 'esim-paid__data-option' +
      (inStock ? '' : ' esim-paid__data-option--sold-out');
    input.type = 'radio';
    input.name = 'esim-paid-data-live';
    input.value = product.sku;
    input.dataset.esimData = '';
    input.checked = Boolean(state.selectedProduct && state.selectedProduct.sku === product.sku);
    card.className = 'esim-paid__data-card';
    title.textContent = dataLabel(product);
    meta.textContent = money(previewPrice(product, state.selectedDays), 'USD') +
      (inStock ? '' : ' · Sold out');

    card.appendChild(title);
    card.appendChild(meta);
    label.appendChild(input);
    label.appendChild(card);
    return label;
  }

  function renderPlanGroups(products) {
    var groups = [
      { type: 'DAILY_QUOTA', title: 'Daily data' },
      { type: 'TOTAL_QUOTA', title: 'Total data' }
    ];
    dataGroups.textContent = '';

    groups.forEach(function (group, groupIndex) {
      var groupProducts = products.filter(function (product) {
        return product.planType === group.type;
      });
      if (!groupProducts.length) return;

      var wrapper = document.createElement('div');
      var heading = document.createElement('span');
      var list = document.createElement('div');
      var headingId = 'esim-live-plan-group-' + groupIndex;
      wrapper.className = 'esim-paid__data-group';
      wrapper.setAttribute('role', 'group');
      wrapper.setAttribute('aria-labelledby', headingId);
      heading.className = 'esim-paid__data-group-title';
      heading.id = headingId;
      heading.textContent = group.title;
      list.className = 'esim-paid__data';

      groupProducts.forEach(function (product) {
        list.appendChild(createPlanOption(product));
      });
      wrapper.appendChild(heading);
      wrapper.appendChild(list);
      dataGroups.appendChild(wrapper);
    });
  }

  function renderPlanDetails() {
    var product = state.selectedProduct;
    if (!product) {
      planInfo.hidden = true;
      availability.hidden = true;
      return;
    }

    var label = dataLabel(product);
    var duration = state.selectedDays + (state.selectedDays === 1 ? ' day' : ' days');
    var daily = product.planType === 'DAILY_QUOTA';
    planNote.textContent = daily
      ? label + ' of high-speed data each day. The allowance resets every 24 hours.'
      : label + ' of high-speed data for the selected ' + duration + ' period.';

    planDetails.textContent = '';
    [
      'Coverage includes mainland China, Hong Kong and Macao.',
      daily
        ? 'The daily allowance resets every 24 hours.'
        : 'The total allowance remains available during the selected period.',
      'The eSIM profile remains valid for ' + product.validityDays + ' days after activation.',
      'After PayPal confirms payment, the QR code is sent automatically to your account email.'
    ].forEach(function (text) {
      var item = document.createElement('li');
      item.textContent = text;
      planDetails.appendChild(item);
    });
    planInfo.hidden = false;

    if (Number(product.availableStock) > 0) {
      setAvailability(
        'Available now · ' + product.availableStock + ' eSIM' +
          (Number(product.availableStock) === 1 ? '' : 's') + ' ready for online purchase.',
        'available'
      );
    } else {
      setAvailability(
        'This plan is temporarily sold out. You can review its price, but purchase stays disabled until inventory is replenished.',
        'sold-out'
      );
    }

    mobilePlan.textContent = duration + ' · ' + label;
  }

  function chooseProduct(products) {
    var previousSignature = state.selectedProduct ? planSignature(state.selectedProduct) : '';
    var selected = products.find(function (product) {
      return planSignature(product) === previousSignature;
    });

    if (!selected) {
      selected = products.find(function (product) {
        return product.planType === 'DAILY_QUOTA' && Number(product.dataAmount) === 2;
      });
    }
    state.selectedProduct = selected || products[0] || null;
  }

  function renderPlansForSelectedDay() {
    var products = productsForDay(state.selectedDays);
    chooseProduct(products);
    renderPlanGroups(products);
    renderPlanDetails();
    state.quote = null;

    dayList.querySelectorAll('[data-esim-days]').forEach(function (button) {
      button.setAttribute(
        'aria-pressed',
        Number(button.dataset.esimDays) === Number(state.selectedDays) ? 'true' : 'false'
      );
    });

    if (state.selectedProduct) {
      quoteSelectedPlan();
    } else {
      setPrice('No plan for these dates');
      syncBuyButtons();
    }
  }

  async function quoteFor(product, days) {
    return apiRequest('/api/v1/esim/price-quote', {
      method: 'POST',
      json: {
        sku: product.sku,
        selectedDays: days,
        quantity: 1
      }
    });
  }

  async function quoteSelectedPlan() {
    var product = state.selectedProduct;
    var requestId = state.quoteRequestId + 1;
    state.quoteRequestId = requestId;
    state.quoteLoading = true;
    state.quote = null;
    setPrice('Confirming price…');
    syncBuyButtons();

    try {
      var quote = await quoteFor(product, state.selectedDays);
      if (requestId !== state.quoteRequestId ||
          !state.selectedProduct ||
          state.selectedProduct.sku !== product.sku) {
        return;
      }
      state.quote = quote;
      setPrice(money(quote.totalPrice, quote.currency));
      ga('select_item', {
        item_list_id: 'esim_plans',
        item_id: product.sku,
        item_name: product.name,
        esim_days: state.selectedDays,
        value: Number(quote.totalPrice),
        currency: quote.currency || 'USD'
      });
    } catch (error) {
      if (requestId !== state.quoteRequestId) return;
      state.quote = null;
      setPrice('Price unavailable');
      ga('esim_quote_failed', {
        item_id: product.sku,
        esim_days: state.selectedDays
      });
      setAvailability(
        friendlyError(error, 'The price could not be confirmed. Choose another plan or try again.'),
        'sold-out'
      );
    } finally {
      if (requestId === state.quoteRequestId) {
        state.quoteLoading = false;
        syncBuyButtons();
      }
    }
  }

  async function loadProducts() {
    if (state.loadingProducts) return;
    state.loadingProducts = true;
    state.quote = null;
    configurator.setAttribute('aria-busy', 'true');
    daysField.hidden = true;
    daysField.disabled = true;
    plansField.hidden = true;
    plansField.disabled = true;
    planInfo.hidden = true;
    availability.hidden = true;
    setProductsMessage('loading', 'Loading current plans and prices…', false);
    setPrice('Loading current price…');
    syncBuyButtons();

    try {
      var products = await apiRequest('/api/v1/esim/products');
      state.products = scopedProducts(Array.isArray(products) ? products : []);
      if (!state.products.length) {
        throw apiError('No China + HK + Macao paid plans are available right now.', 404, 404);
      }

      var stockCount = state.products.filter(function (product) {
        return Number(product.availableStock) > 0;
      }).length;
      setProductsMessage(
        'ready',
        stockCount
          ? 'Live prices and inventory are shown below.'
          : 'Live prices are available, but online purchase is waiting for inventory.',
        false
      );
      renderDays();
      daysField.hidden = false;
      daysField.disabled = false;
      plansField.hidden = false;
      plansField.disabled = false;
      renderPlansForSelectedDay();
      ga('view_item_list', {
        item_list_id: 'esim_plans',
        item_list_name: 'China eSIM plans',
        plan_count: state.products.length,
        in_stock_count: stockCount
      });
    } catch (error) {
      state.products = [];
      state.selectedProduct = null;
      state.quote = null;
      setProductsMessage('error', friendlyError(error, 'Paid eSIM plans could not be loaded.'), true);
      setPrice('Plans unavailable');
      ga('esim_plans_load_failed', {
        error_message: String((error && error.message) || 'unknown').slice(0, 100)
      });
    } finally {
      state.loadingProducts = false;
      configurator.setAttribute('aria-busy', 'false');
      syncBuyButtons();
    }
  }

  function updateCheckoutDelivery() {
    var recipient = recipientInput.value.trim();
    checkoutDelivery.textContent = recipient || checkoutEmail.value || 'Account email';
  }

  function syncPassportFile() {
    var file = checkoutPassport.files && checkoutPassport.files[0];
    passportName.textContent = file ? file.name : 'Choose a clear photo or scan';
    passportRemove.hidden = !file;
    passportUpload.classList.toggle('has-file', Boolean(file));
  }

  function resetCheckoutFiles() {
    checkoutPassport.setCustomValidity('');
    syncPassportFile();
  }

  function removePassportFile() {
    var file = checkoutPassport.files && checkoutPassport.files[0];
    if (file) {
      delete uploadedDocuments[fileSignature(file, 'passport')];
    }
    checkoutPassport.value = '';
    checkoutPassport.setCustomValidity('');
    syncPassportFile();
    checkoutPassport.focus({ preventScroll: true });
  }

  function setCheckoutStatus(message, statusState) {
    checkoutStatus.textContent = message || '';
    checkoutStatus.hidden = !message;
    checkoutStatus.dataset.state = statusState || 'error';
    if (message) checkoutStatus.focus({ preventScroll: false });
  }

  function updateCheckoutSummary() {
    var selection = state.checkoutSelection;
    if (!selection) return;
    var isFree = selection.mode === 'free';
    checkoutPlan.textContent = dataLabel(selection.product);
    checkoutDays.textContent = selection.days + (selection.days === 1 ? ' day' : ' days');
    if (isFree) {
      checkoutPrice.textContent = 'Free';
      totalLabel.textContent = 'You pay';
    } else {
      checkoutPrice.textContent = money(selection.quote.totalPrice, selection.quote.currency);
      totalLabel.textContent = 'Total';
    }
    if (isFree && selection.product.freeTrialNotice) {
      freeNotice.textContent = selection.product.freeTrialNotice;
      freeNotice.hidden = false;
    } else {
      freeNotice.textContent = '';
      freeNotice.hidden = true;
    }
    updateCheckoutDelivery();
    var total = isFree ? 0 : Number(selection.quote.totalPrice || 0);
    if (!state.couponSelector) {
      initEsimCouponSelector(total);
    } else {
      var auth = window.TripCNAuth;
      var isLoggedIn = !!(auth && typeof auth.getAccessToken === 'function' && auth.getAccessToken());
      state.couponSelector.setIsLoggedIn(isLoggedIn);
      state.couponSelector.setEmail(checkoutEmail.value.trim());
      state.couponSelector.setOrderAmount(total);
    }
  }

  function initEsimCouponSelector(total) {
    var container = checkout.querySelector('[data-coupon-selector]');
    if (!container) return;
    var auth = window.TripCNAuth;
    var isLoggedIn = !!(auth && typeof auth.getAccessToken === 'function' && auth.getAccessToken());

    state.couponSelector = new CouponSelector(container, {
      businessType: 'ESIM',
      email: checkoutEmail.value.trim(),
      orderAmount: total,
      isLoggedIn: isLoggedIn,
      onSelect: function (coupon) {
        applyEsimCouponToSummary(coupon);
      },
      beforeLogin: function () {
        if (checkout.open) checkout.close();
      },
      afterLogin: function (user) {
        checkout.showModal();
        document.body.classList.add('esim-checkout-open');
        if (user && user.email && !checkoutEmail.value.trim()) {
          checkoutEmail.value = user.email;
          checkoutEmail.readOnly = true;
          updateCheckoutDelivery();
        }
      }
    });
  }

  function applyEsimCouponToSummary(coupon) {
    var discountRow = checkout.querySelector('[data-esim-coupon-discount-row]');
    var discountName = checkout.querySelector('[data-esim-coupon-discount-name]');
    var discountAmount = checkout.querySelector('[data-esim-coupon-discount-amount]');
    var selection = state.checkoutSelection;
    if (!selection) return;

    var total = Number(selection.quote.totalPrice || 0);
    if (coupon && coupon.discount > 0) {
      discountRow.hidden = false;
      discountName.textContent = 'Coupon (' + coupon.couponName + ')';
      discountAmount.textContent = '-' + money(coupon.discount, selection.quote.currency);
      checkoutPrice.textContent = money(Math.max(0, total - coupon.discount), selection.quote.currency);
    } else if (coupon && coupon.discount === 0) {
      discountRow.hidden = false;
      discountName.textContent = 'Coupon (' + coupon.couponName + ')';
      discountAmount.textContent = '-' + money(0, selection.quote.currency);
      checkoutPrice.textContent = money(total, selection.quote.currency);
    } else {
      discountRow.hidden = true;
      discountName.textContent = 'Coupon';
      discountAmount.textContent = '-$0.00';
      checkoutPrice.textContent = money(total, selection.quote.currency);
    }
  }

  function applyCheckoutMode(mode) {
    checkout.dataset.mode = mode;
    if (mode === 'free') {
      setCheckoutHeader(
        'Free eSIM application',
        'Claim your free China eSIM',
        'Add the traveler details. We’ll review the request and email your QR code.'
      );
      summaryLabel.textContent = 'Application summary';
      paymentNoteText.textContent = 'Reviewed manually · usually within 1 business day.';
      checkoutSubmit.textContent = 'Submit free claim';
    } else {
      setCheckoutHeader(
        checkoutDefaults.eyebrow,
        checkoutDefaults.heading,
        checkoutDefaults.subheading
      );
      summaryLabel.textContent = 'Order summary';
      paymentNoteText.textContent = 'Payment is completed securely on PayPal.';
      checkoutSubmit.textContent = 'Continue to PayPal';
    }
  }

  async function openCheckout(trigger, options) {
    var mode = (options && options.mode) === 'free' ? 'free' : 'paid';
    var product, days, quote;

    if (mode === 'free') {
      product = state.freeProduct;
      if (!product) return;
      days = Number(product.validityDays) || 3;
      quote = null;
    } else {
      if (!canPurchase()) return;
      product = state.selectedProduct;
      days = state.selectedDays;
      quote = state.quote;
    }

    var auth = window.TripCNAuth;
    if (auth && typeof auth.initialize === 'function') {
      await auth.initialize();
    }
    if (mode === 'paid' && !canPurchase()) return;
    var authState = auth && typeof auth.getState === 'function' ? auth.getState() : null;
    var user = authState && authState.user;

    checkoutForm.reset();
    resetCheckoutFiles();
    setCheckoutStatus('');
    hideWaitingView();
    applyCheckoutMode(mode);
    checkoutForm.elements.firstName.setCustomValidity('');
    checkoutForm.elements.lastName.setCustomValidity('');
    if (user && user.email) {
      checkoutEmail.value = user.email;
      checkoutEmail.readOnly = true;
    } else {
      checkoutEmail.value = '';
      checkoutEmail.readOnly = false;
    }
    state.checkoutSelection = {
      mode: mode,
      product: product,
      days: days,
      quote: quote,
      trigger: trigger
    };
    updateCheckoutSummary();
    checkout.showModal();
    document.body.classList.add('esim-checkout-open');
    window.setTimeout(function () {
      checkoutForm.elements.firstName.focus({ preventScroll: true });
    }, 30);
    trackInitiateCheckout(state.checkoutSelection);
    checkoutForm.addEventListener('focusin', trackCheckoutFormStart, { once: true });
  }

  function closeCheckout() {
    if (state.submitting && !state.payment) return;
    if (state.payment) {
      cancelPaymentWait();
      return;
    }
    if (checkout.open) {
      if (!checkoutForm.hidden && state.checkoutSelection) {
        ga('esim_checkout_abandoned', esimParams(state.checkoutSelection, Object.assign(
          { business_line: 'esim_paid' },
          checkoutFieldSnapshot()
        )));
      }
      checkout.close();
    }
  }

  function fileSignature(file, type) {
    return [type, file.name, file.size, file.lastModified].join(':');
  }

  function validateFile(input, required) {
    var file = input.files && input.files[0];
    input.setCustomValidity('');
    if (!file) {
      if (required) input.setCustomValidity('Choose a passport photo or scan.');
      return !required;
    }
    if (file.size > MAX_FILE_SIZE) {
      input.setCustomValidity('Choose a file smaller than 8 MB.');
      return false;
    }
    if (ALLOWED_FILE_TYPES.indexOf(file.type) === -1 &&
        !ALLOWED_FILE_EXTENSION.test(file.name)) {
      input.setCustomValidity('Choose a JPG, PNG, WebP or PDF file.');
      return false;
    }
    return true;
  }

  function validateCheckout() {
    var firstName = checkoutForm.elements.firstName;
    var lastName = checkoutForm.elements.lastName;
    firstName.setCustomValidity(
      firstName.value.trim() ? '' : 'Enter the first name shown on the passport.'
    );
    lastName.setCustomValidity(
      lastName.value.trim() ? '' : 'Enter the last name shown on the passport.'
    );
    validateFile(checkoutPassport, true);
    if (!checkoutForm.checkValidity()) {
      checkoutForm.reportValidity();
      ga('esim_checkout_validation_failed', esimParams(state.checkoutSelection, Object.assign(
        { business_line: 'esim_paid' },
        checkoutFieldSnapshot()
      )));
      return false;
    }
    return true;
  }

  async function uploadDocument(file, type) {
    if (!file) return null;
    var signature = fileSignature(file, type);
    if (uploadedDocuments[signature]) return uploadedDocuments[signature];

    var body = new FormData();
    body.append('file', file);
    var result = await apiRequest('/api/v1/upload/document?type=' + encodeURIComponent(type), {
      method: 'POST',
      body: body
    });
    if (!result || !result.url) {
      throw apiError('The document upload did not return a file URL.', 500, 500);
    }
    uploadedDocuments[signature] = result.url;
    return result.url;
  }

  function paypalUrl(value) {
    var url;
    try {
      url = new URL(value);
    } catch (error) {
      throw apiError('PayPal returned an invalid checkout address.', 502, 502);
    }
    var hostname = url.hostname.toLowerCase();
    if (url.protocol !== 'https:' ||
        (hostname !== 'paypal.com' && !hostname.endsWith('.paypal.com'))) {
      throw apiError('PayPal returned an invalid checkout address.', 502, 502);
    }
    return url.href;
  }

  function samePrice(first, second) {
    return Math.abs(Number(first) - Number(second)) < 0.005;
  }

  /* ---------- GA4 funnel helpers ---------- */

  function ga(eventName, params) {
    if (window.tcng) window.tcng.track(eventName, params);
  }

  /** Track when the user first focuses any field in the checkout form. */
  var checkoutFormStarted = false;
  function trackCheckoutFormStart() {
    if (checkoutFormStarted) return;
    checkoutFormStarted = true;
    ga('esim_checkout_form_start', esimParams(state.checkoutSelection, { business_line: 'esim_paid' }));
    checkoutForm.removeEventListener('focusin', trackCheckoutFormStart);
  }

  /**
   * Snapshot of which required checkout fields are filled in, without ever
   * sending the actual values (name/passport file are PII). Used both when
   * validation fails on submit and when the user abandons the dialog, so we
   * can tell "never touched the passport upload" apart from "picked a file
   * that failed validation" apart from "filled everything but never hit
   * submit".
   */
  function checkoutFieldSnapshot() {
    var firstName = checkoutForm.elements.firstName;
    var lastName = checkoutForm.elements.lastName;
    var consent = checkoutForm.elements.documentConsent;
    return {
      has_first_name: Boolean(firstName && firstName.value.trim()),
      has_last_name: Boolean(lastName && lastName.value.trim()),
      has_passport_file: Boolean(checkoutPassport.files && checkoutPassport.files[0]),
      has_consent: Boolean(consent && consent.checked)
    };
  }

  /** Shared dimensions for every eSIM funnel event. */
  function esimParams(selection, extra) {
    var params = extra || {};
    if (selection) {
      params.esim_mode = selection.mode;
      params.esim_days = selection.days;
      if (selection.product) {
        params.item_id = selection.product.sku;
        params.item_name = selection.product.name;
      }
      if (params.value === undefined) {
        params.value = selection.quote ? Number(selection.quote.totalPrice) : 0;
      }
      if (params.currency === undefined) {
        params.currency = (selection.quote && selection.quote.currency) || 'USD';
      }
    }
    return params;
  }

  function esimItems(selection, order) {
    if (!selection || !selection.product) return [];
    return [{
      item_id: selection.product.sku,
      item_name: selection.product.name,
      item_category: 'esim',
      item_variant: String(selection.days) + 'd',
      price: Number(order && order.totalPrice) || 0,
      quantity: 1
    }];
  }

  function trackInitiateCheckout(selection) {
    ga('begin_checkout', esimParams(selection, {
      business_line: selection.mode === 'free' ? 'esim_free' : 'esim_paid',
      items: esimItems(selection, selection.quote)
    }));

    if (typeof window.fbq !== 'function') return;
    var value = selection.quote ? Number(selection.quote.totalPrice) : 0;
    var currency = (selection.quote && selection.quote.currency) || 'USD';
    window.fbq('track', 'InitiateCheckout', {
      content_name: selection.product.name,
      content_ids: [selection.product.sku],
      content_type: 'product',
      value: value,
      currency: currency,
      paid_days: selection.days
    });
  }

  function trackPaymentInfo(selection, order) {
    ga('add_payment_info', esimParams(selection, {
      business_line: 'esim_paid',
      transaction_id: order.orderNo,
      value: Number(order.totalPrice),
      currency: order.currency || 'USD',
      payment_type: 'PayPal',
      items: esimItems(selection, order)
    }));

    if (typeof window.fbq !== 'function') return;
    window.fbq('track', 'AddPaymentInfo', {
      content_name: selection.product.name,
      content_ids: [selection.product.sku],
      content_type: 'product',
      value: Number(order.totalPrice),
      currency: order.currency || 'USD'
    });
  }

  function openPayPalWindow(approveUrl) {
    var popup = window.open(
      approveUrl || '',
      '_blank',
      'popup=yes,width=1024,height=780,resizable=yes,scrollbars=yes'
    );
    if (!popup) return null;
    if (!approveUrl) {
      try {
        popup.document.title = 'Preparing PayPal checkout';
        popup.document.body.textContent = 'Preparing your secure PayPal checkout...';
        popup.document.body.style.cssText =
          'margin:0;display:grid;place-items:center;min-height:100vh;' +
          'font:16px/1.5 system-ui,sans-serif;color:#334155;background:#f8fafc';
      } catch (error) {
        /* The checkout can continue when the preparation message is unavailable. */
      }
    }
    try { popup.focus(); } catch (error) { /* ignore */ }
    return popup;
  }

  function navigatePayPalWindow(popup, approveUrl) {
    if (!popup || popup.closed) {
      throw apiError('The PayPal window was closed before checkout was ready. Try again.');
    }
    try {
      popup.opener = null;
      popup.location.href = approveUrl;
      popup.focus();
    } catch (error) {
      try { popup.close(); } catch (closeError) { /* ignore */ }
      throw apiError('Unable to open the PayPal checkout. Allow popups and try again.');
    }
  }

  function closePayPalWindow(popup) {
    if (!popup) return;
    try {
      if (!popup.closed) popup.close();
    } catch (error) {
      /* ignore */
    }
  }

  function setCheckoutHeader(eyebrow, heading, subheading) {
    checkoutEyebrow.textContent = eyebrow;
    checkoutHeading.textContent = heading;
    checkoutSubheading.textContent = subheading;
  }

  function showWaitingView(order, selection) {
    checkoutForm.hidden = true;
    waitingView.hidden = false;
    setCheckoutHeader(
      'Awaiting payment',
      'Waiting for PayPal to confirm your payment',
      'We opened PayPal in a new window. This page updates automatically.'
    );
    waitingVisual.dataset.state = 'pending';
    if (waitingIconPending) waitingIconPending.hidden = false;
    if (waitingIconSuccess) waitingIconSuccess.hidden = true;
    waitingTitle.textContent = waitingDefaults.title;
    waitingCopy.textContent = waitingDefaults.copy;
    waitingRef.textContent = order.orderNo || order.referenceId || order.esimOrderId || '—';
    waitingTotal.textContent = money(order.totalPrice, order.currency);
    waitingStatusEl.hidden = false;
    setWaitingStatus('progress', 'Checking payment status…');
    waitingReopen.hidden = true;
    waitingDone.hidden = true;
    waitingMyOrders.hidden = true;
    waitingCancel.hidden = false;
    waitingCancel.disabled = false;
    waitingCancel.textContent = 'I’ll pay later';
    checkoutCloseButtons.forEach(function (button) {
      button.disabled = false;
    });
    window.setTimeout(function () {
      waitingCancel.focus({ preventScroll: true });
    }, 30);
  }

  function hideWaitingView() {
    waitingView.hidden = true;
    checkoutForm.hidden = false;
    waitingMyOrders.hidden = true;
    setCheckoutHeader(
      checkoutDefaults.eyebrow,
      checkoutDefaults.heading,
      checkoutDefaults.subheading
    );
  }

  function setWaitingStatus(statusState, message) {
    waitingStatusEl.dataset.state = statusState || 'progress';
    waitingStatusText.textContent = message;
  }

  function clearPollTimers(payment) {
    if (!payment) return;
    if (payment.timerId) {
      window.clearTimeout(payment.timerId);
      payment.timerId = null;
    }
    if (payment.deadlineId) {
      window.clearTimeout(payment.deadlineId);
      payment.deadlineId = null;
    }
    if (payment.popupWatchId) {
      window.clearInterval(payment.popupWatchId);
      payment.popupWatchId = null;
    }
  }

  async function fetchOrderStatus(order) {
    if (!order || !order.orderNo) {
      throw apiError('The order number is unavailable.', 500, 500);
    }
    return apiRequest(
      '/api/v1/esim/orders/' + encodeURIComponent(order.orderNo),
      { authorized: true }
    );
  }

  function showReviewSubmitted(order, selection) {
    if (window.tcng) {
      window.tcng.trackLead({
        businessLine: 'esim_free',
        referenceId: order.orderNo || order.referenceId || order.esimOrderId
      });
    }
    checkoutForm.hidden = true;
    waitingView.hidden = false;
    setCheckoutHeader(
      'Application received',
      'We’re reviewing your free eSIM application',
      'Our team will approve your request and email the QR code.'
    );
    waitingVisual.dataset.state = 'success';
    if (waitingIconPending) waitingIconPending.hidden = true;
    if (waitingIconSuccess) waitingIconSuccess.hidden = false;
    waitingTitle.textContent = 'Application submitted';
    var recipient = (recipientInput && recipientInput.value.trim()) ||
      (checkoutEmail && checkoutEmail.value) || '';
    waitingCopy.textContent = recipient
      ? 'Thanks — we received your free eSIM application. Our team will review it (usually within 1 business day) and email the QR code to ' + recipient + ' once approved.'
      : 'Thanks — we received your free eSIM application. Our team will review it (usually within 1 business day) and email the QR code once approved.';
    waitingRef.textContent = order.orderNo || order.referenceId || order.esimOrderId || '—';
    waitingTotal.textContent = 'Free';
    waitingStatusEl.hidden = true;
    waitingReopen.hidden = true;
    waitingCancel.hidden = true;
    waitingDone.hidden = false;
    waitingMyOrders.hidden = true;
    state.payment = null;
    state.submitting = false;
    checkoutSubmit.disabled = false;
    checkoutCloseButtons.forEach(function (button) {
      button.disabled = false;
    });
    syncBuyButtons();
    window.setTimeout(function () {
      waitingDone.focus({ preventScroll: true });
    }, 30);
  }

  function handlePaymentSuccess(payment, result) {
    clearPollTimers(payment);
    if (window.tcng) {
      window.tcng.trackPurchase({
        orderNo: payment.order.orderNo,
        value: payment.order.totalPrice,
        currency: payment.order.currency,
        businessLine: 'esim_paid',
        items: esimItems(payment.selection, payment.order)
      });
    }
    state.payment = null;
    state.submitting = false;
    checkoutSubmit.disabled = false;
    try {
      window.sessionStorage.removeItem('tcng_esim_pending_order');
    } catch (storageError) {
      /* ignore */
    }
    if (payment.popup && !payment.popup.closed) {
      try { payment.popup.close(); } catch (closeError) { /* ignore */ }
    }
    try { window.focus(); } catch (focusError) { /* ignore */ }
    waitingVisual.dataset.state = 'success';
    if (waitingIconPending) waitingIconPending.hidden = true;
    if (waitingIconSuccess) waitingIconSuccess.hidden = false;
    var status = String(result && result.status || '').toUpperCase();
    var recipient = (result && result.recipientEmail) ||
      (payment.selection && payment.selection.recipientEmail) ||
      (recipientInput && recipientInput.value.trim()) ||
      (checkoutEmail && checkoutEmail.value) || '';

    if (status === 'PAID_NO_STOCK') {
      waitingTitle.textContent = 'Payment received — support is handling your order';
      waitingCopy.textContent =
        'Your payment was successful, but inventory is temporarily unavailable. Our support team will contact you within 24 hours. You can follow the latest status in My Orders.';
    } else if (status === 'DELIVERED') {
      waitingTitle.textContent = 'Payment successful — your eSIM is ready';
      waitingCopy.textContent = recipient
        ? 'Your eSIM details have been sent to ' + recipient + '. You can also review the order in My Orders.'
        : 'Your eSIM details have been sent by email. You can also review the order in My Orders.';
    } else {
      waitingTitle.textContent = 'Payment successful';
      waitingCopy.textContent = recipient
        ? 'PayPal confirmed your payment. We’re preparing the eSIM and will email it to ' + recipient + ' shortly. You can track progress in My Orders.'
        : 'PayPal confirmed your payment. We’re preparing the eSIM and will email it shortly. You can track progress in My Orders.';
    }
    setCheckoutHeader(
      'Payment successful',
      status === 'DELIVERED' ? 'Your eSIM is ready' : 'Your eSIM order is being processed',
      'View the latest fulfillment status at any time in My Orders.'
    );
    setWaitingStatus(
      status === 'PAID_NO_STOCK' ? 'warning' : 'success',
      status === 'DELIVERED'
        ? 'Payment confirmed · eSIM delivered'
        : status === 'PAID_NO_STOCK'
          ? 'Payment confirmed · support follow-up required'
          : 'Payment confirmed · preparing your eSIM'
    );
    waitingReopen.hidden = true;
    waitingCancel.hidden = true;
    waitingDone.hidden = false;
    waitingMyOrders.hidden = false;
    checkoutCloseButtons.forEach(function (button) {
      button.disabled = false;
    });
    syncBuyButtons();
    window.setTimeout(function () {
      waitingMyOrders.focus({ preventScroll: true });
    }, 30);
  }

  function handlePaymentFailure(payment, message) {
    clearPollTimers(payment);
    ga('esim_payment_failed', {
      business_line: 'esim_paid',
      transaction_id: payment.order && payment.order.orderNo,
      error_message: String(message || '').slice(0, 100)
    });
    state.payment = null;
    state.submitting = false;
    checkoutSubmit.disabled = false;
    checkoutCloseButtons.forEach(function (button) {
      button.disabled = false;
    });
    hideWaitingView();
    setCheckoutStatus(message, 'error');
    syncBuyButtons();
  }

  function handlePaymentTimeout(payment) {
    clearPollTimers(payment);
    ga('esim_payment_timeout', {
      business_line: 'esim_paid',
      transaction_id: payment.order && payment.order.orderNo
    });
    setWaitingStatus(
      'error',
      'We stopped watching after 15 minutes. Refresh this page after paying to confirm the order.'
    );
    waitingReopen.hidden = false;
    waitingCancel.textContent = 'Close';
    waitingMyOrders.hidden = false;
  }

  async function pollPaymentStatus() {
    var payment = state.payment;
    if (!payment) return;
    payment.timerId = null;

    try {
      var result = await fetchOrderStatus(payment.order);
      if (state.payment !== payment) return;
      var status = String(result && result.status || '').toUpperCase();
      if (status === 'PAID' || status === 'DELIVERED' || status === 'PAID_NO_STOCK') {
        handlePaymentSuccess(payment, result);
        return;
      }
      if (status === 'CANCELLED' || status === 'CANCELED' || status === 'EXPIRED' ||
          status === 'REFUNDED' || (status === 'PENDING_PAYMENT' && result.paymentExpired)) {
        handlePaymentFailure(payment,
          status === 'CANCELLED' || status === 'CANCELED'
            ? 'PayPal reported the payment was canceled. No charge was made.'
            : status === 'REFUNDED'
              ? 'This order has been refunded. View My Orders for details.'
              : 'The PayPal payment link has expired. No charge was made.'
        );
        return;
      }
      setWaitingStatus('progress', 'Waiting for PayPal to confirm payment…');
    } catch (error) {
      if (state.payment !== payment) return;
      var code = Number(error && (error.code || error.status)) || 0;
      if (code === 401 || code === 403 || code === 404) {
        handlePaymentFailure(
          payment,
          code === 401
            ? 'Your session expired while checking the order. Log in again and open My Orders.'
            : 'We could not access this order. Open My Orders or contact support.'
        );
        return;
      }
      setWaitingStatus(
        'progress',
        'Connection hiccup. Retrying in a moment…'
      );
    }

    if (state.payment === payment) {
      payment.timerId = window.setTimeout(pollPaymentStatus, POLL_INTERVAL_MS);
    }
  }

  function watchPayPalPopup(payment) {
    payment.popupWatchId = window.setInterval(function () {
      if (state.payment !== payment) {
        window.clearInterval(payment.popupWatchId);
        payment.popupWatchId = null;
        return;
      }
      if (payment.popup && payment.popup.closed) {
        window.clearInterval(payment.popupWatchId);
        payment.popupWatchId = null;
        waitingReopen.hidden = false;
        ga('esim_paypal_popup_closed', {
          business_line: 'esim_paid',
          transaction_id: payment.order && payment.order.orderNo
        });
        setWaitingStatus(
          'progress',
          'PayPal tab closed. If you already paid, we’re still checking.'
        );
      }
    }, 1500);
  }

  function reopenPayPal() {
    var payment = state.payment;
    if (!payment) return;
    var popup = openPayPalWindow(payment.approveUrl);
    if (!popup) {
      setWaitingStatus(
        'error',
        'Your browser blocked the PayPal window. Allow popups and try again.'
      );
      return;
    }
    payment.popup = popup;
    ga('esim_paypal_reopened', {
      business_line: 'esim_paid',
      transaction_id: payment.order && payment.order.orderNo
    });
    waitingReopen.hidden = true;
    waitingMyOrders.hidden = true;
    waitingCancel.textContent = 'I’ll pay later';
    setWaitingStatus('progress', 'Checking payment status…');
    if (!payment.popupWatchId) watchPayPalPopup(payment);
    if (!payment.timerId && !payment.deadlineId) {
      payment.deadlineId = window.setTimeout(function () {
        handlePaymentTimeout(payment);
      }, POLL_TIMEOUT_MS);
      payment.timerId = window.setTimeout(pollPaymentStatus, POLL_INTERVAL_MS);
    }
  }

  function beginPaymentWait(order, selection, popup) {
    var payment = {
      order: order,
      selection: selection,
      approveUrl: order._approveUrl,
      popup: popup,
      timerId: null,
      deadlineId: null,
      popupWatchId: null
    };
    state.payment = payment;
    showWaitingView(order, selection);
    if (popup && !popup.closed) {
      watchPayPalPopup(payment);
    } else {
      waitingReopen.hidden = false;
      setWaitingStatus(
        'error',
        'Your browser blocked the PayPal window. Reopen it to continue.'
      );
    }
    payment.deadlineId = window.setTimeout(function () {
      handlePaymentTimeout(payment);
    }, POLL_TIMEOUT_MS);
    payment.timerId = window.setTimeout(pollPaymentStatus, POLL_INTERVAL_MS);
  }

  function cancelPaymentWait() {
    var payment = state.payment;
    if (!payment) {
      if (checkout.open) checkout.close();
      return;
    }
    var stopWatching = window.confirm(
      'Stop watching for the PayPal payment? You can still finish paying in the other tab, but this window will not confirm it automatically.'
    );
    if (!stopWatching) return;
    clearPollTimers(payment);
    ga('esim_payment_abandoned', {
      business_line: 'esim_paid',
      transaction_id: payment.order && payment.order.orderNo
    });
    state.payment = null;
    state.submitting = false;
    checkoutSubmit.disabled = false;
    checkoutCloseButtons.forEach(function (button) {
      button.disabled = false;
    });
    hideWaitingView();
    setCheckoutStatus('', 'error');
    if (checkout.open) checkout.close();
    syncBuyButtons();
  }

  async function submitCheckout(event) {
    event.preventDefault();
    if (state.submitting || !state.checkoutSelection) return;
    ga('esim_checkout_submit_click', esimParams(state.checkoutSelection, { business_line: 'esim_paid' }));
    if (!validateCheckout()) return;

    var selection = state.checkoutSelection;
    var isFree = selection.mode === 'free';
    var paymentPopup = isFree ? null : openPayPalWindow('');
    if (!isFree && !paymentPopup) {
      setCheckoutStatus(
        'Your browser blocked the PayPal window. Allow popups for this site and try again.',
        'error'
      );
      return;
    }
    state.submitting = true;
    checkoutSubmit.disabled = true;
    checkoutCloseButtons.forEach(function (button) {
      button.disabled = true;
    });
    syncBuyButtons();
    setCheckoutStatus(
      isFree ? 'Preparing your application…' : 'Confirming the latest price…',
      'progress'
    );

    try {
      if (!isFree) {
        var latestQuote = await quoteFor(selection.product, selection.days);
        var currencyChanged = String(latestQuote.currency || 'USD') !==
          String(selection.quote.currency || 'USD');
        if (!samePrice(latestQuote.totalPrice, selection.quote.totalPrice) || currencyChanged) {
          selection.quote = latestQuote;
          if (state.selectedProduct &&
              state.selectedProduct.sku === selection.product.sku &&
              Number(state.selectedDays) === Number(selection.days)) {
            state.quote = latestQuote;
            setPrice(money(latestQuote.totalPrice, latestQuote.currency));
          }
          updateCheckoutSummary();
          ga('esim_price_changed', esimParams(selection, {
            business_line: 'esim_paid',
            value: Number(latestQuote.totalPrice),
            currency: latestQuote.currency || 'USD'
          }));
          var changed = apiError(
            'The plan price changed. Review the new total, then continue again.'
          );
          changed.priceChanged = true;
          throw changed;
        }
      }

      setCheckoutStatus('Uploading the passport securely…', 'progress');
      var passportUrl = await uploadDocument(checkoutPassport.files[0], 'passport');
      ga('esim_passport_uploaded', esimParams(selection, {
        business_line: isFree ? 'esim_free' : 'esim_paid'
      }));

      setCheckoutStatus(
        isFree ? 'Submitting your application…' : 'Creating the order and opening PayPal…',
        'progress'
      );
      var order = await apiRequest('/api/v1/esim/order', {
        method: 'POST',
        authorized: true,
        json: {
          sku: selection.product.sku,
          customerEmail: checkoutEmail.value.trim(),
          selectedDays: selection.days,
          quantity: 1,
          firstName: checkoutForm.elements.firstName.value.trim(),
          lastName: checkoutForm.elements.lastName.value.trim(),
          passportUrl: passportUrl,
          recipientEmail: recipientInput.value.trim() || null,
          userCouponId: state.couponSelector && state.couponSelector.getSelectedUserCouponId()
            ? state.couponSelector.getSelectedUserCouponId()
            : undefined
        }
      });
      order.createdAt = order.createdAt || new Date().toISOString();

      if (isFree) {
        setCheckoutStatus('', 'error');
        showReviewSubmitted(order, selection);
        return;
      }

      if (!order.approveUrl) {
        throw apiError('PayPal did not return a checkout address.', 502, 502);
      }
      if (!order.orderNo) {
        throw apiError('The eSIM service did not return an order number.', 500, 500);
      }

      var approveUrl = paypalUrl(order.approveUrl);
      order._approveUrl = approveUrl;

      try {
        window.sessionStorage.setItem('tcng_esim_pending_order', JSON.stringify({
          orderNo: order.orderNo,
          esimOrderId: order.esimOrderId,
          referenceId: order.referenceId,
          sku: selection.product.sku,
          totalPrice: order.totalPrice,
          currency: order.currency,
          createdAt: order.createdAt
        }));
      } catch (storageError) {
        /* Payment can continue when session storage is unavailable. */
      }

      trackPaymentInfo(selection, order);
      navigatePayPalWindow(paymentPopup, approveUrl);
      selection.recipientEmail = recipientInput.value.trim() || checkoutEmail.value.trim();
      beginPaymentWait(order, selection, paymentPopup);
      paymentPopup = null;
      return;
    } catch (error) {
      closePayPalWindow(paymentPopup);
      paymentPopup = null;
      var code = Number(error && (error.code || error.status)) || 0;
      if (code === 401 &&
          window.TripCNAuth &&
          typeof window.TripCNAuth.signOut === 'function') {
        window.TripCNAuth.signOut();
      }
      if (isFree && code === 409) {
        ga('esim_free_already_claimed', esimParams(selection, {
          business_line: 'esim_free'
        }));
      } else if (!error || !error.priceChanged) {
        ga('esim_order_create_failed', esimParams(selection, {
          business_line: isFree ? 'esim_free' : 'esim_paid',
          error_code: code || undefined,
          error_message: String((error && error.message) || 'unknown').slice(0, 100)
        }));
      }
      if (!isFree && code === 409 &&
          state.selectedProduct &&
          state.selectedProduct.sku === selection.product.sku) {
        state.selectedProduct.availableStock = 0;
        renderPlanDetails();
      }
      setCheckoutStatus(
        error && error.priceChanged
          ? error.message
          : friendlyError(
              error,
              isFree
                ? 'The application could not be submitted. Please try again.'
                : 'The order could not be created. No payment was taken.',
              { mode: selection.mode }
            ),
        'error'
      );
    } finally {
      if (!state.payment) {
        state.submitting = false;
        checkoutSubmit.disabled = false;
        checkoutCloseButtons.forEach(function (button) {
          button.disabled = false;
        });
        syncBuyButtons();
      }
    }
  }

  function initializeMobileBar() {
    if (!('IntersectionObserver' in window) || !mobileBar || !desktopBuyButton) return;
    var configuratorVisible = false;
    var desktopBuyVisible = false;
    var mobileQuery = window.matchMedia('(max-width: 900px)');

    function syncMobilePurchase() {
      var mobile = mobileQuery.matches;
      var showBar = mobile && configuratorVisible && !desktopBuyVisible;
      mobileBar.classList.toggle('is-visible', showBar);
      mobileBar.setAttribute('aria-hidden', showBar ? 'false' : 'true');
      mobileBuyButton.setAttribute('tabindex', showBar ? '0' : '-1');
      document.body.classList.toggle('esim-paid-configuring', mobile && configuratorVisible);
    }

    var configuratorObserver = new IntersectionObserver(function (entries) {
      configuratorVisible = entries[0].isIntersecting;
      syncMobilePurchase();
    }, { threshold: 0.01, rootMargin: '-72px 0px -12% 0px' });
    var desktopBuyObserver = new IntersectionObserver(function (entries) {
      desktopBuyVisible = entries[0].isIntersecting;
      syncMobilePurchase();
    }, { threshold: 0.35 });

    configuratorObserver.observe(configurator);
    desktopBuyObserver.observe(desktopBuyButton);
    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', syncMobilePurchase);
    }
  }

  dayList.addEventListener('click', function (event) {
    var button = event.target.closest('[data-esim-days]');
    if (!button || !dayList.contains(button) || state.submitting) return;
    state.selectedDays = Number(button.dataset.esimDays);
    renderPlansForSelectedDay();
  });

  dataGroups.addEventListener('change', function (event) {
    var input = event.target.closest('[data-esim-data]');
    if (!input || !dataGroups.contains(input) || state.submitting) return;
    state.selectedProduct = state.products.find(function (product) {
      return product.sku === input.value;
    }) || null;
    renderPlanDetails();
    quoteSelectedPlan();
  });

  productsRetry.addEventListener('click', loadProducts);
  buyButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      openCheckout(button, { mode: 'paid' });
    });
  });
  document.querySelectorAll('[data-esim-claim-open]').forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      openCheckout(button, { mode: 'free' });
    });
  });

  checkoutCloseButtons.forEach(function (button) {
    button.addEventListener('click', closeCheckout);
  });

  checkout.addEventListener('cancel', function (event) {
    if (state.payment) {
      event.preventDefault();
      cancelPaymentWait();
      return;
    }
    if (state.submitting) {
      event.preventDefault();
      return;
    }
    /* Esc key closes the native <dialog> directly, bypassing closeCheckout()'s
       own abandon tracking, so report it here too. */
    if (!checkoutForm.hidden && state.checkoutSelection) {
      ga('esim_checkout_abandoned', esimParams(state.checkoutSelection, Object.assign(
        { business_line: 'esim_paid' },
        checkoutFieldSnapshot()
      )));
    }
  });

  checkout.addEventListener('close', function () {
    document.body.classList.remove('esim-checkout-open');
    var trigger = state.checkoutSelection && state.checkoutSelection.trigger;
    if (trigger && document.contains(trigger)) trigger.focus();
  });

  checkoutPassport.addEventListener('change', function () {
    checkoutPassport.setCustomValidity('');
    syncPassportFile();
    var file = checkoutPassport.files && checkoutPassport.files[0];
    if (!file) return;
    if (file.size > MAX_FILE_SIZE) {
      ga('esim_passport_file_invalid', esimParams(state.checkoutSelection, {
        business_line: 'esim_paid',
        reason: 'too_large'
      }));
    } else if (ALLOWED_FILE_TYPES.indexOf(file.type) === -1 && !ALLOWED_FILE_EXTENSION.test(file.name)) {
      ga('esim_passport_file_invalid', esimParams(state.checkoutSelection, {
        business_line: 'esim_paid',
        reason: 'bad_format'
      }));
    } else {
      ga('esim_passport_selected', esimParams(state.checkoutSelection, { business_line: 'esim_paid' }));
    }
  });

  passportRemove.addEventListener('click', removePassportFile);
  recipientInput.addEventListener('input', updateCheckoutDelivery);
  checkoutEmail.addEventListener('input', function () {
    updateCheckoutDelivery();
    if (state.couponSelector) {
      state.couponSelector.setEmail(checkoutEmail.value.trim());
    }
  });
  checkoutForm.addEventListener('submit', submitCheckout);
  waitingReopen.addEventListener('click', reopenPayPal);
  waitingCancel.addEventListener('click', cancelPaymentWait);
  waitingDone.addEventListener('click', function () {
    state.submitting = false;
    checkoutSubmit.disabled = false;
    hideWaitingView();
    if (checkout.open) checkout.close();
    syncBuyButtons();
  });

  initializeMobileBar();
  loadProducts();
})();
